/**
 * Generates a unique id for a DOM element based on a psuedo-random
 * timestamp based approach and an optional passed id. While there is still
 * the change for collisions, unless measurements are taken less than 1ms apart,
 * this chance is so small it almost isn't worth mentioning
 */

export default function generateUniqueId(id = '') {
  const unique =
    Math.random()
      .toString(36)
      .substring(2) + new Date().getTime().toString(36)
  return id !== '' ? `${id}-${unique}` : unique
}
